var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3fd13c9-fdf6-44c1-ae30-b251c88634bc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.37 1079.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b531216c-2553-4a2f-aa7c-91bd3e6c5f56 {\n        fill: #7e7f7f;\n      }\n\n      .a0d8dbce-d53a-4eed-ad5a-ed4373da0fcf {\n        fill: #929393;\n      }\n\n      .f00e3181-7d07-4ffd-abf3-0080142271c1 {\n        fill: #a4a4a4;\n      }\n\n      .a5a069fe-95ee-4bdf-acd5-6b709ed97884 {\n        fill: #9b9b9b;\n      }\n\n      .a865f3ca-3241-4f9c-9d15-b3d910356486 {\n        fill: #bdbdbd;\n      }\n\n      .b1e80f5e-5c81-43f1-8f48-c5bfa4452bbe {\n        fill: #b7b7b8;\n      }\n\n      .ae20fa41-3ef9-4a75-a20d-c04bc7b3ff05 {\n        fill: #9b9d9d;\n      }\n\n      .a1313f3a-1ab1-4d79-a9ee-b0fd8726132c {\n        fill: #aeadae;\n      }\n\n      .e1069b3f-72e3-4be6-8015-d0f14626cd6b {\n        fill: silver;\n      }\n\n      .a3959517-128c-4701-9dee-82d0dc59df73 {\n        fill: #bbb;\n      }\n\n      .ffdad560-b1ff-4084-a52a-7d6ec0c99365 {\n        fill: #cfcfce;\n      }\n\n      .a93624f9-e32b-46de-a051-d83c9ee662f8 {\n        fill: #dddede;\n      }\n\n      .b0aa7744-8178-40d4-950d-d201452bcecb {\n        fill: #dcdbdb;\n      }\n\n      .bf1372fb-737d-4f9b-8b0d-b315aca76003 {\n        fill: #e4e5e5;\n      }\n\n      .b71deb51-aa00-4cd2-b3ff-6b1918021819 {\n        fill: #dad9da;\n      }\n\n      .a5f8e435-f7ce-48a7-a759-3551e3ea5dac {\n        fill: #eaecec;\n      }\n\n      .a3c25af3-0205-4b4a-a804-ab1df2441a82 {\n        fill: #f2f3f4;\n      }\n\n      .f377c037-2c80-4b77-a07e-41c326dfd57c {\n        fill: #cac9c9;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fond") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b531216c-2553-4a2f-aa7c-91bd3e6c5f56",
    points: "304.11 1079.03 190.09 846.28 142.99 1079.03 304.11 1079.03"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a0d8dbce-d53a-4eed-ad5a-ed4373da0fcf",
    points: "190.09 846.28 142.99 1079.03 93.24 1079.03 0 1039.75 0 995.9 190.09 846.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b531216c-2553-4a2f-aa7c-91bd3e6c5f56",
    points: "93.24 1079.03 0 1079.03 0 1039.75 93.24 1079.03"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a0d8dbce-d53a-4eed-ad5a-ed4373da0fcf",
    points: "347.37 872.71 347.37 1024.66 326.18 1079.03 304.11 1079.03 190.09 846.28 347.37 872.71"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "f00e3181-7d07-4ffd-abf3-0080142271c1",
    points: "347.37 852.13 347.37 872.71 190.09 846.28 266.84 808.77 347.37 852.13"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "a5a069fe-95ee-4bdf-acd5-6b709ed97884",
    points: "190.09 846.28 0 995.9 0 868.13 190.09 846.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "a0d8dbce-d53a-4eed-ad5a-ed4373da0fcf",
    points: "190.09 846.28 0 868.13 0 671.08 190.09 846.28"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "a865f3ca-3241-4f9c-9d15-b3d910356486",
    points: "347.37 1024.66 347.37 1079.03 326.18 1079.03 347.37 1024.66"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "a0d8dbce-d53a-4eed-ad5a-ed4373da0fcf",
    points: "347.37 801.98 347.37 852.13 266.84 808.77 347.37 801.98"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "b1e80f5e-5c81-43f1-8f48-c5bfa4452bbe",
    points: "190.09 846.28 266.84 808.77 105.04 491.23 190.09 846.28"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "a865f3ca-3241-4f9c-9d15-b3d910356486",
    points: "190.09 846.28 0 671.08 0 558.92 105.04 491.23 190.09 846.28"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "ae20fa41-3ef9-4a75-a20d-c04bc7b3ff05",
    points: "347.37 728.24 347.37 801.98 266.84 808.77 105.04 491.23 347.37 728.24"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "a1313f3a-1ab1-4d79-a9ee-b0fd8726132c",
    points: "347.37 639.43 347.37 728.24 105.04 491.23 231.29 377.39 347.37 639.43"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "ae20fa41-3ef9-4a75-a20d-c04bc7b3ff05",
    points: "347.37 384.08 347.37 639.43 231.29 377.39 347.37 384.08"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "f00e3181-7d07-4ffd-abf3-0080142271c1",
    points: "231.29 377.38 89.36 424.06 105.04 491.23 231.29 377.38"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "e1069b3f-72e3-4be6-8015-d0f14626cd6b",
    points: "105.04 491.23 0 558.92 0 524.54 89.36 424.06 105.04 491.23"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "a3959517-128c-4701-9dee-82d0dc59df73",
    points: "89.36 424.06 0 315.23 231.29 377.38 89.36 424.06"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "ffdad560-b1ff-4084-a52a-7d6ec0c99365",
    points: "89.36 424.06 0 524.54 0 315.23 89.36 424.06"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "b1e80f5e-5c81-43f1-8f48-c5bfa4452bbe",
    points: "347.37 322.83 347.37 384.08 231.29 377.39 347.37 322.83"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "ffdad560-b1ff-4084-a52a-7d6ec0c99365",
    points: "347.37 228.42 347.37 322.83 231.29 377.39 226.38 207.93 347.37 228.42"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "f00e3181-7d07-4ffd-abf3-0080142271c1",
    points: "231.29 377.38 0 315.23 226.38 207.93 231.29 377.38"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "a93624f9-e32b-46de-a051-d83c9ee662f8",
    points: "347.37 64.51 347.37 228.42 226.38 207.93 347.37 64.51"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "b0aa7744-8178-40d4-950d-d201452bcecb",
    points: "347.37 14.46 347.37 64.51 226.38 207.93 151.57 124.83 347.37 14.46"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "a1313f3a-1ab1-4d79-a9ee-b0fd8726132c",
    points: "151.57 124.83 226.38 207.93 0 315.23 151.57 124.83"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "bf1372fb-737d-4f9b-8b0d-b315aca76003",
    points: "347.37 0 347.37 14.46 151.57 124.83 209.2 0 347.37 0"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "b71deb51-aa00-4cd2-b3ff-6b1918021819",
    points: "209.2 0 151.57 124.83 85.96 0 209.2 0"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "a5f8e435-f7ce-48a7-a759-3551e3ea5dac",
    points: "151.57 124.83 0 41.91 0 0 85.96 0 151.57 124.83"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "a3c25af3-0205-4b4a-a804-ab1df2441a82",
    points: "151.57 124.83 0 161.08 0 41.91 151.57 124.83"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "f377c037-2c80-4b77-a07e-41c326dfd57c",
    points: "151.57 124.83 0 315.23 0 161.08 151.57 124.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygone);
export default __webpack_public_path__ + "static/media/polygone.618bb6a9e41b0f6cb2328d8158d578fd.svg";
export { ForwardRef as ReactComponent };